module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/store_images/2_053511d16f471248e4ffb7fded226d9b.png";